"use strict";

var _classCallCheck = require("/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/node_modules/@babel/runtime/helpers/inherits");

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 0;\n\n  button {\n    padding: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var buttons_1 = require("../buttons");

var HeaderContainer = styled_components_1.default.div(_templateObject());
var CircleButtonContainer = styled_components_1.default.div(_templateObject2());

var MobileHeader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MobileHeader, _React$Component);

  function MobileHeader() {
    _classCallCheck(this, MobileHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(MobileHeader).apply(this, arguments));
  }

  _createClass(MobileHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          mobileLeft = _this$props.mobileLeft,
          mobileRight = _this$props.mobileRight;
      return React.createElement(HeaderContainer, {
        id: id
      }, mobileLeft && React.createElement(CircleButtonContainer, null, React.createElement(buttons_1.CircleButton, {
        id: "mobile_header_left",
        onClick: mobileLeft.handler,
        dark: true
      }, mobileLeft.icon && mobileLeft.icon())), mobileRight && React.createElement("div", null, React.createElement(buttons_1.SecondaryButton, {
        id: "mobile_header_right",
        onClick: mobileRight.handler
      }, mobileRight.title)));
    }
  }]);

  return MobileHeader;
}(React.Component);

exports.MobileHeader = MobileHeader;